import React, { useState, useEffect } from "react";
import { newsData } from "../../data/news-data";

function SkeletonCard() {
  return (
    <div className="mb-4 break-inside-avoid rounded-md">
      <div className="overflow-hidden bg-blue-700 rounded-md">
        <div className="w-full h-48 bg-gray-300 animate-pulse" />

        <div className="bg-gray-100 p-3 flex flex-col justify-between h-60">
          <div>
            <div className="h-10 w-full bg-gray-200 rounded animate-pulse mb-5" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
            <div className="mt-2 h-3 w-full bg-gray-200 rounded animate-pulse" />
          </div>
          <div className="mt-3 h-3 w-2/4 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
}

function LatestNewsCard({ item }) {
  return (
    <div
      className="group mb-4 this group-hover:bg-sddarkgray text-black group-hover:text-white rounded-md 
          transition-colors duration-300 ease-in-out  "
    >
      <div className="h-48 w-full bg-amber-500 rounded-t-md overflow-hidden relative">
        <img
          src={item.image800 || item.image400} // fallback ok
          srcSet={`${item.image400} 400w, ${item.image800} 800w`}
          sizes="(min-width:1024px) 33vw, (min-width:640px) 50vw, 100vw"
          alt={item.title}
          className="absolute inset-0 w-full h-full object-cover block"
          width="800"
          height="450"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="p-3 h-60 flex flex-col justify-between">
        <div>
          <div className="font-bold">{item.title}</div>
          <div className="mt-2">{item.minidescription}</div>
        </div>
        <div className="mt-2 text-sm opacity-70"> {item.date} </div>
      </div>
    </div>
  );
}

const HomeLatestNews2 = () => {
  const [news, setNews] = useState([]);
  useEffect(() => {
    setNews(newsData);
  }, []);

  return (
    <div>
      <div className="max-w-6xl mx-auto px-4 sm:px-2 py-12">
        {news.map((item) => (
          <LatestNewsCard key={item.id} item={item} />
        ))}

        <SkeletonCard />
      </div>
    </div>
  );
};

export default HomeLatestNews2;
